module.exports = __webpack_public_path__ + "img/login.0f35630a.svg";